import axios, { AxiosError } from "axios";

import config from "@web-app/config";

const http = axios.create({
  baseURL: config.WEB_API_URL,
  headers: {
    Authorization: `Bearer ${localStorage.getItem("apiToken")}`,
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("apiToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["x-request-id"] = crypto.randomUUID();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

let isRedirecting = false;

http.interceptors.response.use(
  (response) => response,
  (error: unknown) => {
    if (error && typeof error === "object" && "isAxiosError" in error) {
      const axiosError = error as AxiosError;
      const status = axiosError.response?.status;

      if (status === 401) {
        if (!isRedirecting && window.location.pathname !== "/signin") {
          isRedirecting = true;
          localStorage.removeItem(config.API_TOKEN);
          setTimeout(() => {
            window.location.href = "/signin";
          }, 100);
        }
      }
    }

    return Promise.reject(error);
  },
);

export default http;
